module.exports = __webpack_public_path__ + "img/2.172963bb.svg";